import React from 'react';
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { Button } from 'baseui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter, ROLE } from 'baseui/modal';
import { Textarea } from 'baseui/textarea';
import { Select } from 'baseui/select';
import useStore from '../store';

export function ServiceForm() {
  const store = useStore();
  const [formData, setFormData] = React.useState({
    name: '',
    description: '',
    authMethods: []
  });

  const authMethodOptions = [
    { id: 'api_key', label: 'API Key' },
    { id: 'oauth2', label: 'OAuth 2.0' }
  ];

  React.useEffect(() => {
    if (store.selectedService) {
      // Convert authMethods array to Select value format
      const authMethodValues = store.selectedService.authMethods?.map(method => ({
        id: method,
        label: method === 'api_key' ? 'API Key' : 'OAuth 2.0'
      })) || [];

      setFormData({
        ...store.selectedService,
        authMethods: authMethodValues
      });
    }
  }, [store.selectedService]);

  const handleSubmit = async () => {
    // Convert Select values back to simple array of strings
    const submitData = {
      ...formData,
      authMethods: formData.authMethods.map(method => method.id)
    };

    if (submitData.id) {
      await store.updateService(submitData.id, submitData);
    } else {
      await store.createService(submitData);
    }
    store.setSelectedService(null);
  };

  return (
    <Modal
      onClose={() => store.setSelectedService(null)}
      isOpen={!!store.selectedService}
      role={ROLE.dialog}
    >
      <ModalHeader>{formData.id ? 'Edit Service' : 'Create Service'}</ModalHeader>
      <ModalBody>
        <FormControl label="Name">
          <Input
            value={formData.name || ''}
            onChange={e => setFormData({ ...formData, name: e.target.value })}
            placeholder="Service name"
          />
        </FormControl>
        <FormControl label="Description">
          <Textarea
            value={formData.description || ''}
            onChange={e => setFormData({ ...formData, description: e.target.value })}
            placeholder="Service description"
          />
        </FormControl>
        <FormControl label="Authentication Methods">
          <Select
            multi
            options={authMethodOptions}
            value={formData.authMethods}
            onChange={({ value }) => setFormData({ ...formData, authMethods: value })}
            placeholder="Select authentication methods"
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <Button kind="tertiary" onClick={() => store.setSelectedService(null)}>Cancel</Button>
        <Button onClick={handleSubmit}>{formData.id ? 'Update' : 'Create'}</Button>
      </ModalFooter>
    </Modal>
  );
}
